import { useQuery } from "@tanstack/react-query";
import { useEffect, useMemo, useState } from "react";
import { getAIRequestApi } from "services/getApis";
import { ErrorHandler } from "utils/toast";
import "../styles/Questionnaire.css";
import LoaderPulse from "components/Loader/LoaderPulse";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

const HerbalPlan = () => {
  const [contraCount, setContraCount] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userSubmissionId =
    location.state?.userSubmissionId ||
    searchParams.get("userSubmissionId");
  // const [isOrderLoading, setIsOrderLoading] = useState(false);

  const { data, refetch, isError, error, isLoading, isRefetching } = useQuery({
    queryKey: ["getHerbalPlan", userSubmissionId],
    queryFn: () => getAIRequestApi(userSubmissionId),
    enabled: !!userSubmissionId,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const responseData = useMemo(() => data?.payload, [data]);
  console.log("Response Data", responseData);

  useEffect(() => {
    if (userSubmissionId) {
      refetch();
    } else {
      navigate("/questionnaire", { replace: true });
    }
  }, [userSubmissionId, refetch, navigate]);

  useEffect(() => {
    if (isError) {
      ErrorHandler(error?.message);
    }
  }, [isError, error]);

  // const { mutate: mutateOrder } = useMutation({
  //   mutationFn: orderHerbsApi,
  //   onSuccess: (data) => {
  //     console.log("Order Success", data);
  //     navigate(`/consent/${userSubmissionId}`, {
  //       replace: true,
  //       state: {
  //         userSubmissionId: userSubmissionId,
  //       },
  //     });
  //   },
  //   onError: (error) => {
  //     console.log("Order Error", error);
  //     ErrorHandler("Failed to place order. Please try again.");
  //   },
  //   onSettled: () => {
  //     // setIsOrderLoading(false);
  //   },
  // });

  const handleRefetch = () => {
    setContraCount((prev) => prev + 1);
    refetch();
  };

  // "Everything Looks Good" → navigate directly to consultation options
  const handleEverythingLooksGood = () => {
    navigate("/consultation-options", {
      state: { userSubmissionId, responseData },
    });
  };

  // "I Noticed A Contradiction" → first time: regenerate plan; second time onwards: navigate to consultation options
  const handleNoticedContradiction = () => {
    if (contraCount === 0) {
      handleRefetch();
    } else {
      navigate("/consultation-options", {
        state: { userSubmissionId, responseData },
      });
    }
  };

  if (!userSubmissionId) {
    return null;
  }

  return (
    <div className="questionnaire-container">
      <div className="questionnaire-content">
        {isLoading || isRefetching ? (
          <div
            style={{
              marginTop: "35%",
            }}
          >
            <LoaderPulse
              text={contraCount !== 0 && "Regenerating Treatment..."}
            />
          </div>
        ) : (
          <div
            style={{
              marginTop: "10%",
            }}
          >
            <>
              <div className="completion-screen">
                <h2 className="completion-title">
                  Your Personalized Herbal Plan is Ready
                </h2>
                <p className="completion-subtitle">
                  Based on your responses, we've created a customized herbal
                  treatment plan tailored to your needs.
                </p>

                <div className="contraindications-card">
                  <h3 className="contraindications-title">
                    Review Potential Contradictions
                  </h3>
                  <div className="contraindications-list">
                    {responseData?.contraindications?.length > 0 ? (
                      responseData?.contraindications?.map((res, ind) => {
                        return (
                          <div className="contraindication-item" key={ind}>
                            - {res}{" "}
                          </div>
                        );
                      })
                    ) : (
                      <div className="contraindication-item">
                        - No Contradictions Found
                      </div>
                    )}
                  </div>
                </div>

                <div className="completion-buttons">
                  <button
                    className="approval-btn primary"
                    onClick={handleEverythingLooksGood}
                  >
                    Everything Looks Good
                  </button>
                  <button
                    className="approval-btn secondary"
                    onClick={handleNoticedContradiction}
                  >
                    I Noticed A Contradiction
                  </button>
                </div>
              </div>
            </>
          </div>
        )}
      </div>
    </div>
  );
};

export default HerbalPlan;
